export const SetMenus = [
  {
    name: "Thực đơn 1",
    price: 999,
    title: "Ngỗng các món/6 người",
    foods: [
      {
        name: "Tiết canh",
        price: 0,
      },
      {
        name: "Cổ nhồi",
        price: 0,
      },
      {
        name: "Lòng mề xào giá mướp",
        price: 0,
      },
      {
        name: "Nem thính",
        price: 0,
      },
      {
        name: "Hấp lá thơm",
        price: 0,
      },
      {
        name: "Chao cháy tỏi",
        price: 0,
      },
      {
        name: "Xào lăn",
        price: 0,
      },
      {
        name: "Canh xương khoai + bún",
        price: 0,
      },
      {
        name: "Cháo đổ xanh",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
  {
    name: "Thực đơn 2",
    price: 999,
    title: "Lợn mán các món/6 người",
    foods: [
      {
        name: "Tiết canh",
        price: 0,
      },
      {
        name: "Lòng trần giá đỗ",
        price: 0,
      },
      {
        name: "Nem thính",
        price: 0,
      },
      {
        name: "Lợn hấp",
        price: 0,
      },
      {
        name: "Lợn xào húng quế",
        price: 0,
      },
      {
        name: "Lợn chiên riềng xả",
        price: 0,
      },
      {
        name: "Canh xương khoai + bún",
        price: 0,
      },
      {
        name: "Cháo đỗ xanh",
        price: 0,
      },
      {
        name: "Rượu mận",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
  {
    name: "Thực đơn 3",
    title: "Dê các món/6 người",
    price: 1300,
    foods: [
      {
        name: "Tiết canh",
        price: 0,
      },
      {
        name: "Dê hấp",
        price: 0,
      },
      {
        name: "Dê xào măng trúc",
        price: 0,
      },
      {
        name: "Dê tái chanh",
        price: 0,
      },
      {
        name: "Dê cháy tỏi",
        price: 0,
      },
      {
        name: "Lẩu dê nhúng mẻ (or chua cay)",
        price: 0,
      },
      {
        name: "Cháo dê",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
  {
    name: "Thực đơn 4",
    title: "Cá tầm các món/6 người",
    price: 1200,
    foods: [
      {
        name: "Cá tầm trộn hành tím",
        price: 0,
      },
      {
        name: "Cá tầm xào nấm",
        price: 0,
      },
      {
        name: "Cá tầm rang muối",
        price: 0,
      },
      {
        name: "Cá tầm nướng (bún + bánh đa)",
        price: 0,
      },
      {
        name: "Lẩu (or hấp xì dầu)",
        price: 0,
      },
      {
        name: "Cháo đỗ xanh",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
  {
    name: "Thực đơn 5",
    price: 1800,
    title: "Cá song món/6 người",
    foods: [
      {
        name: "Nộm bò rau tiến vua",
        price: 0,
      },
      {
        name: "Gỏi cá song",
        price: 0,
      },
      {
        name: "Cá song nướng",
        price: 0,
      },
      {
        name: "Cá song hấp xì dầu (or lẩu)",
        price: 0,
      },
      {
        name: "Cháo đỗ xanh",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
  {
    name: "Thực đơn 6",
    title: "Thực đơn cỗ/tiệc/hội nghị",
    price: 1200,
    foods: [
      {
        name: "Nộm sứa xoài dừa",
        price: 0,
      },
      {
        name: "Gà hấp lá chanh",
        price: 0,
      },
      {
        name: "Cá diêu hồng chiên xù",
        price: 0,
      },
      {
        name: "Chim câu quay lá móc mật",
        price: 0,
      },
      {
        name: "Bê cào măng trúc",
        price: 0,
      },
      {
        name: "Khoai tây lắc phô mai",
        price: 0,
      },
      {
        name: "Củ quả luộc chấm muối vừng",
        price: 0,
      },
      {
        name: "Canh măng sườn",
        price: 0,
      },
      {
        name: "Giò lụa",
        price: 0,
      },
      {
        name: "Xôi hoàng phố",
        price: 0,
      },
      {
        name: "Cơm tám",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
  {
    name: "Thực đơn 7",
    title: "Thực đơn cỗ/tiệc/hội nghị",
    price: 1200,
    foods: [
      {
        name: "Nộm bò rau tiến vua",
        price: 0,
      },
      {
        name: "Gà hấp lá chanh",
        price: 0,
      },
      {
        name: "Ngọn su su xào tỏi",
        price: 0,
      },
      {
        name: "Mực ống chiên bơ",
        price: 0,
      },
      {
        name: "Bò sốt vang + bánh mỳ",
        price: 0,
      },
      {
        name: "Cá diêu hồng hấp xì dầu",
        price: 0,
      },
      {
        name: "Canh mọc nấm thập cẩm",
        price: 0,
      },
      {
        name: "Xôi hoàng phố",
        price: 0,
      },
      {
        name: "Cơm tám",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
  {
    name: "Thực đơn 8",
    title: "Thực đơn cỗ/tiệc/hội nghị",
    price: 1300,
    foods: [
      {
        name: "Nộm giò tai heo thập cẩm",
        price: 0,
      },
      {
        name: "Gà hấp lá chanh",
        price: 0,
      },
      {
        name: "Cá quả nướng giấy bạc",
        price: 0,
      },
      {
        name: "Ốc om chuối đậu + bún",
        price: 0,
      },
      {
        name: "Bê xào măng trúc",
        price: 0,
      },
      {
        name: "Khoai tây lắc phô mai",
        price: 0,
      },
      {
        name: "Ba chỉ chiên riềng xả",
        price: 0,
      },
      {
        name: "Canh ngao chua",
        price: 0,
      },
      {
        name: "Xôi hoàng phố",
        price: 0,
      },
      {
        name: "Cơm tám",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
  {
    name: "Thực đơn 9",
    title: "Thực đơn cỗ/tiệc/hội nghị",
    price: 1400,
    foods: [
      {
        name: "Shup gà nấm hương",
        price: 0,
      },
      {
        name: "Nộm bò rau tiến vua",
        price: 0,
      },
      {
        name: "Gà hấp lá chanh",
        price: 0,
      },
      {
        name: "Tôm chiên hạnh nhân",
        price: 0,
      },
      {
        name: "Chân giò hầm nấm sen",
        price: 0,
      },
      {
        name: "Bò lúc lắc khoai tây",
        price: 0,
      },
      {
        name: "Nem hải sản",
        price: 0,
      },
      {
        name: "Ngọn su xào tỏi",
        price: 0,
      },
      {
        name: "Canh mộc nấm thập cẩm",
        price: 0,
      },
      {
        name: "Xôi hoàng phố",
        price: 0,
      },
      {
        name: "Cơm tám",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
  {
    name: "Thực đơn 10",
    title: "Thực đơn cỗ/tiệc/hội nghị",
    price: 1500,
    foods: [
      {
        name: "Nộm ngũ sắc",
        price: 0,
      },
      {
        name: "Gà hấp lá chanh",
        price: 0,
      },
      {
        name: "Tôm chiên hoàng bào",
        price: 0,
      },
      {
        name: "Cá lăng nướng dân tộc + bún",
        price: 0,
      },
      {
        name: "Nem hải sản",
        price: 0,
      },
      {
        name: "Ốc xào măng trúc",
        price: 0,
      },
      {
        name: "Bò sốt vang + bánh mỳ",
        price: 0,
      },
      {
        name: "Cải chíp xào nấm",
        price: 0,
      },
      {
        name: "Canh mộc nấm sườn",
        price: 0,
      },
      {
        name: "Xôi hoàng phố",
        price: 0,
      },
      {
        name: "Cơm trắng",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
  {
    name: "Thực đơn 11",
    title: "Thực đơn cỗ/tiệc/hội nghị",
    price: 1600,
    foods: [
      {
        name: "Nộm sứa xoài dừa",
        price: 0,
      },
      {
        name: "Gà nướng mật ong",
        price: 0,
      },
      {
        name: "Tôm chiên xen dừa",
        price: 0,
      },
      {
        name: "Bê xào măng trúc",
        price: 0,
      },
      {
        name: "Ba ba om chuối đậu",
        price: 0,
      },
      {
        name: "Mực xào hoa nơ thập cẩm",
        price: 0,
      },
      {
        name: "Cải chíp xào nấm",
        price: 0,
      },
      {
        name: "Miến xào hải sản",
        price: 0,
      },
      {
        name: "Xôi vò hạt sen",
        price: 0,
      },
      {
        name: "Cơm tám",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
  {
    name: "Thực đơn 12",
    title: "Thực đơn cỗ/tiệc/hội nghị",
    price: 1700,
    foods: [
      {
        name: "Salat trứng cua rong biển",
        price: 0,
      },
      {
        name: "Sup gà tam tơ",
        price: 0,
      },
      {
        name: "Tôm hấp trái dừa",
        price: 0,
      },
      {
        name: "Mực xào hoa nơ thập cẩm",
        price: 0,
      },
      {
        name: "Gà hấp lá chanh",
        price: 0,
      },
      {
        name: "Bò hầm kiểu pháp + bánh mỳ",
        price: 0,
      },
      {
        name: "Ngọn su su xào tỏi",
        price: 0,
      },
      {
        name: "Ba ba om chuối đậu + bún",
        price: 0,
      },
      {
        name: "Giò bò",
        price: 0,
      },
      {
        name: "Xôi vò hạt sen",
        price: 0,
      },
      {
        name: "Cơm trắng",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
  {
    name: "Thực đơn 13",
    title: "Thực đơn cỗ/tiệc/hội nghị",
    price: 1850,
    foods: [
      {
        name: "Nộm sứa xoài dừa",
        price: 0,
      },
      {
        name: "Tôm chiên hoàng bào",
        price: 0,
      },
      {
        name: "Mực xào ngũ sắc",
        price: 0,
      },
      {
        name: "Gà hấp lá chanh",
        price: 0,
      },
      {
        name: "Bò lúc lắc + khoai tây",
        price: 0,
      },
      {
        name: "Bê tái chanh",
        price: 0,
      },
      {
        name: "Nem hải sản",
        price: 0,
      },
      {
        name: "Cá song hấp xì dầu",
        price: 0,
      },
      {
        name: "Cải chíp xào nấm",
        price: 0,
      },
      {
        name: "Xôi hoàng phố",
        price: 0,
      },
      {
        name: "Cơm tám",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
  {
    name: "Thực đơn 14",
    price: 2000,
    foods: [
      {
        name: "Gỏi bò rau tiến vua",
        price: 0,
      },
      {
        name: "Tôm hấp nước dừa",
        price: 0,
      },
      {
        name: "Mực xào sa tế",
        price: 0,
      },
      {
        name: "Bê xào măng trúc",
        price: 0,
      },
      {
        name: "Gà hấp lá chanh",
        price: 0,
      },
      {
        name: "Bề bề xốt me",
        price: 0,
      },
      {
        name: "Bò sốt vang + bánh mỳ",
        price: 0,
      },
      {
        name: "Cá song hấp xì dầu",
        price: 0,
      },
      {
        name: "Cải chíp xào nấm",
        price: 0,
      },
      {
        name: "Xôi hoàng phố",
        price: 0,
      },
      {
        name: "Cơm tám",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
  {
    name: "Thực đơn 15",
    title: "Thực đơn cúng rằm/giỗ",
    price: 1100,
    foods: [
      {
        name: "Nộm tai heo hoa chuối",
        price: 0,
      },
      {
        name: "Tôm hấp nước dừa",
        price: 0,
      },
      {
        name: "Mực xào ngũ sắc",
        price: 0,
      },
      {
        name: "Gà hấp lá chanh",
        price: 0,
      },
      {
        name: "Canh măng sườn",
        price: 0,
      },
      {
        name: "Nem hải sản",
        price: 0,
      },
      {
        name: "Cải chip xào nấm",
        price: 0,
      },
      {
        name: "Xôi hoàng phố",
        price: 0,
      },
      {
        name: "Cơm tám",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
  {
    name: "Thực đơn 16",
    title: "Thực đơn cúng rằm/giỗ",
    price: 999,
    foods: [
      {
        name: "Nộm sứa xoài dừa",
        price: 0,
      },
      {
        name: "Bò sốt vang + bánh mỳ",
        price: 0,
      },
      {
        name: "Bê tái chanh",
        price: 0,
      },
      {
        name: "Ốc xào măng trúc",
        price: 0,
      },
      {
        name: "Gà hấp lá chanh",
        price: 0,
      },
      {
        name: "Lòng xào giá mướp",
        price: 0,
      },
      {
        name: "Canh mộc nấm sườn",
        price: 0,
      },
      {
        name: "Xôi hoàng phố",
        price: 0,
      },
      {
        name: "Cơm tám",
        price: 0,
      },
      {
        name: "Tráng miệng bưởi hồng da xanh",
        price: 0,
      },
    ],
  },
];
